enum DocumentTypes {
    Image = 1,
    PDF = 2,
    URL = 3
}

export class DocumentTypesEnum_class {
    public static enum = DocumentTypes;

    public static readonly enumByText: {[key: string]: number} = {
        'Image': 1,
        'PDF': 2,
        'URL': 3,
    }

    public static readonly enumByNumber: {[key: number]: string} = {
        1: 'Image',
        2: 'PDF',
        3: 'URL',
    }
}